var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 25.3815C41.4001 33.3894 35.3684 40.9296 26.9049 42.6144C22.7771 43.4373 18.4952 42.9356 14.6688 41.1807C10.8425 39.4257 7.66672 36.5071 5.5938 32.8403C3.52087 29.1735 2.65644 24.9455 3.12359 20.7583C3.59073 16.5711 5.36564 12.6382 8.19558 9.51952C14.0001 3.11964 23.8011 1.35791 31.8006 4.56105",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 22.1783L23.8003 30.1862L42.9992 9.36572",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success_check.49854dfd6c1fa3e6d6b16393b33cf702.svg";
export { ForwardRef as ReactComponent };